import { useTranslation } from 'react-i18next';

import Cancel from '@/icons/cancel.svg';
import CircleCheck from '@/icons/check-circle.svg';
import { isFeatureChecked } from '@/pages/Checkout/hooks';

function PlansFeatures({ plans }) {
	const { t } = useTranslation();

	const features = t('billing.features.table.items', { returnObjects: true });

	return (
		<div className="mt-[4.25rem] flex w-full flex-col pb-20">
			<h2 className="pb-12 font-title text-4xl font-semibold leading-[52px]">
				{t('billing.features.title')}
			</h2>

			<table className="border border-grey-200 bg-white p-4 font-semibold leading-7">
				<thead>
					<tr>
						<th className="border border-grey-200 p-4 text-left font-semibold leading-7">
							{t('billing.features.table.title')}
						</th>
						{plans.map(plan => {
							return (
								<td
									className="border border-grey-200 p-4 text-center font-semibold"
									key={plan.name}
								>
									{t(`plans.${plan.name}.name`)}
								</td>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{features.map((feat, index) => (
						<tr className="border border-grey-200" key={feat}>
							<th className="border border-grey-200 p-4 text-left font-semibold leading-7 text-grey-500">
								{feat}
							</th>
							{plans.map(plan => {
								const ariaLabel = isFeatureChecked(plan.name, index)
									? t('common.yes')
									: t('common.no');

								return (
									<td
										aria-label={ariaLabel}
										className="border border-grey-200 p-4 text-center font-semibold text-grey-500"
										key={plan.name + index}
									>
										{isFeatureChecked(plan.name, index) ? (
											<CircleCheck
												aria-hidden
												className="m-auto text-black"
											/>
										) : (
											<Cancel aria-hidden className="m-auto" />
										)}
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

export default PlansFeatures;
